const normalizeNumericInput = (value) => {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }

    const raw = String(value).trim();

    if (!raw) {
        return null;
    }

    const sanitized = raw
        .replace(/[\s\u00A0\u202F]/g, '')
        .replace(/[^0-9,\.\-]/g, '');

    if (!sanitized || sanitized === '-' || sanitized === '+') {
        return null;
    }

    const lastComma = sanitized.lastIndexOf(',');
    const lastDot = sanitized.lastIndexOf('.');
    let normalized = sanitized;

    if (lastComma > lastDot) {
        normalized = normalized.replace(/\./g, '').replace(/,/g, '.');
    } else {
        normalized = normalized.replace(/,/g, '');
    }

    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : null;
};

export const parsePriceValue = (value) => normalizeNumericInput(value);

export const formatPrice = (price) => {
    const amount = normalizeNumericInput(price);

    if (amount === null) {
        return '';
    }

    const [intPart, decimalPart] = amount.toFixed(2).split('.');
    const spacedIntPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${spacedIntPart},${decimalPart} €`;
};
